const option = {
  /**
   * 是否为选择题
   * @param {string} id
   */
  isChoice (id) {
    return ['select', 'multiselect', 'imageMultiselect'].includes(this.indexes[id].data.type)
  },

  /**
   * 题目选项是否已选中
   * @param {string} id
   */
  // isSelectedOption (id) {
  //   let indexe = this.indexes[id]
  //   let answer = this.indexes[indexe.question.id].answer
  //   return answer.selectedOptionId.indexOf(id) !== -1
  // },

  /**
   * 清理题目中的互斥选项(答案)
   * @param {string} questionId
   * @param {string} optionId
   */
  removeMutexOptions (questionId, optionId) {
    let indexe = this.indexes[questionId + optionId]
    let selectedOptionId = this.indexes[indexe.question.id].answer.selectedOptionId
    // 清理互斥选项
    let option = indexe.data
    option.mutexOptions.forEach(value => {
      // 删除已选择的选项
      let index = selectedOptionId.indexOf(value)
      if (index !== -1) {
        selectedOptionId.splice(index, 1)
      }
    })
  },

  /**
   * 改变题目选中的选项
   * @param {string} questionId
   * @param {string} optionId
   */
  changeSelectedOption (questionId, optionId) {
    let optionIndexe = this.indexes[questionId + optionId]
    let questionIndexe = this.indexes[optionIndexe.question.id]
    let type = questionIndexe.data.type
    let selectedOptionId = questionIndexe.answer.selectedOptionId
    // 单选只保留一个选项, 多选至少保留一个选项
    if (type === 'select' && selectedOptionId[0] !== optionId) {
      selectedOptionId.splice(0, selectedOptionId.length)
      selectedOptionId.push(optionId)
    } else if (['multiselect', 'imageMultiselect'].indexOf(type) !== -1) {
      let index = selectedOptionId.indexOf(optionId)
      // 已存在则删除选项
      if (index === -1) {
        selectedOptionId.push(optionId)
        // 移除互斥的选项
        this.removeMutexOptions(questionId, optionId)
      } else {
        if (selectedOptionId.length > 1) {
          selectedOptionId.splice(index, 1)
        } else {
          return false
        }
      }
    } else {
      return false
    }

    // 更新索引跳转信息
    this.updateIndexeJumped()

    return true
  },

  /**
   * 更改多项填空题的答案
   * @param {string} id
   * @param {string} value
   */
  // changeMultitextValue (id, value) {
  //   let optionIndexe = this.indexes[id]
  //   let option = optionIndexe.data
  //   let index = optionIndexe.index()
  //   let answer = this.indexes[optionIndexe.question.id].answer
  //   // 验证输入内容
  //   if (this.validateMultitextValue(option, value)) {
  //     answer.texts[index] = value
  //     return true
  //   }
  //   return false
  // },

  validateMultitextValue (option, value) {
    // 必填未填写
    if (option.required && !value) {
      return false
    }
    // 值存在验证格式
    if (value && !this.validateValueType(value, option.inputType)) {
      return false
    }
    return true
  },

  /**
   * 验证输入的文本
   * @param value
   * @param type
   * @returns {boolean}
   */
  validateValueType (value, type) {
    switch (type) {
      case 'text':
        return true
      case 'numberInt':
        return /^\d+$/.test(value)
      case 'numberFloat':
        return /(^\d+\.\d{1,9}$)|(^\d+$)/.test(value)
      case 'date':
        return moment(value, 'YYYY-MM-DD', true).isValid()
      default:
        return false
    }
  }
}

export default option



// WEBPACK FOOTER //
// ./src/views/question-review/review/option.js